import React, {useEffect} from 'react'
import {Button} from 'antd-mobile'
import './index.scss'
import animoji from './images/animoji.png'
import animoji1 from './images/animoji1.png'
import animoji2 from './images/animoji2.png'
import animoji3 from './images/animoji3.png'
import animoji4 from './images/animoji4.png'
import animoji5 from './images/animoji5.png'
import animoji6 from './images/animoji6.png'
import animoji7 from './images/animoji7.png'

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://cdn.jsdelivr.net/npm/tsparticles@2.11.1/tsparticles.bundle.min.js'
    script.onload = () => {
      window.tsParticles.load('tsparticles', {
        background: {
          color: '#0a0a1a',
        },
        fpsLimit: 60,
        interactivity: {
          detectsOn: 'canvas',
          events: {
            onHover: {
              enable: true,
              mode: 'repulse',
            },
            resize: true,
          },
          modes: {
            repulse: {
              distance: 80,
              duration: 0.4,
            },
          },
        },
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              area: 800,
            },
          },
          color: {
            value: ['#ffffff', '#8ab4f8', '#43e8ff', '#9f73ff'],
          },
          shape: {
            type: 'circle',
          },
          opacity: {
            value: 0.4,
            random: true,
            anim: {
              enable: true,
              speed: 0.6,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: {min: 1, max: 3},
          },
          links: {
            enable: true,
            distance: 120,
            color: '#ffffff',
            opacity: 0.2,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.3,
            direction: 'none',
            random: true,
            straight: false,
            outModes: 'out',
            attract: {
              enable: false,
            },
          },
        },
        detectRetina: true,
      })
    }
    document.body.appendChild(script)
  }, [])

  const getYear = () => new Date().getFullYear()

  return (
    <div className="homepage">
      <div id="tsparticles" className="particles-background" />
      <header className="header">
        <nav className="nav container">
          <div className="logo">CLOUD TECHNOLOGY CORPORATION LIMITED</div>
          <div className="nav-links">
            <a href="#">Products</a>
            <a href="#">Document</a>
            <a href="#">Customers</a>
            <a href="#">Resources</a>
          </div>
          <div className="nav-actions button-group">
            {/* <Button className="demo-button" size="mini">Book a Demo</Button> */}
            <Button className="login-button" size="mini" fill="none">
              Log In
            </Button>
          </div>
        </nav>
      </header>

      <section className="hero container">
        <br />
        <h1>
          <span>Humanizing social connections through technology</span>
        </h1>
        <br />
        <p>
          CLOUD TECHNOLOGY CORPORATION LIMITED innovates to connect souls,making
          every interaction meaningful.{' '}
        </p>
        <br />
        <div className="hero-buttons inline-buttons">
          {/* <Button className="demo-button" size="mini">Book a Demo</Button> */}
          <Button className="ai-button" size="mini" fill="none">
            Coming soon →
          </Button>
        </div>
        {/* <img className="hero-img" src={heroImg} /> */}
      </section>

      <section className="about container">
        <span className="section-tag">Technology Changes Life</span>
        <h2>About Us</h2>
        <p>We are a team of experts...</p>
        {/* <img src="https://via.placeholder.com/600x300" alt="about visual" /> */}
        <div className="us-engine-blocks">
          <div className="us-engine-block">
            <h3>Timer</h3>
            <p>Chief Product</p>
            <img src={animoji} />
          </div>
          <div className="us-engine-block">
            <h3>Zachary Reed</h3>
            <p>design expert</p>
            <img src={animoji1} />
          </div>
          <div className="us-engine-block">
            <h3>Julian Carter</h3>
            <p>Client Expert</p>
            <img src={animoji2} />
          </div>
          <div className="us-engine-block">
            <h3>Tyler Grant</h3>
            <p>Client Expert</p>
            <img src={animoji3} />
          </div>

          <div className="us-engine-block">
            <h3>Ethan Cole</h3>
            <p>Server experts</p>
            <img src={animoji4} />
          </div>
          <div className="us-engine-block">
            <h3>Nathan Brooks</h3>
            <p>Server experts</p>
            <img src={animoji5} />
          </div>
          <div className="us-engine-block">
            <h3>Liam Chase</h3>
            <p>Server experts</p>
            <img src={animoji6} />
          </div>
          <div className="us-engine-block">
            <h3>shriley</h3>
            <p>Chief Test Engineer</p>
            <img src={animoji7} />
          </div>
        </div>
      </section>

      <section className="data-engine container">
        <span className="section-tag">AuthenticConnections</span>
        <h2>Our Mission</h2>
        <p>Connecting souls, not just profiles.</p>
        <div className="engine-blocks">
          <div className="engine-block">
            <h3>Industry leader</h3>
            <p>
              CloudTop is committed to building the next-gen social platform
              with human warmth. By pioneering technologies that blur the lines
              between virtual and real, we empower global users to forge
              meaningful digital bonds. We believe true technology should bring
              people closer, not farther apart.
            </p>
            {/* <img src="https://via.placeholder.com/400x200" alt="data labeling" /> */}
          </div>
          <div className="engine-block">
            <h3>Embrace the needs of users</h3>
            <p>
              We build social experiences where opening the app feels like
              stepping into your digital living room – algorithms that recall
              your favorite topics, avatars that reveal your true self, and
              every encounter could blossom into meaningful connections.
            </p>
            {/* <img src="https://via.placeholder.com/400x200" alt="data curation" /> */}
          </div>
        </div>
      </section>

      <section className="applications container">
        <span className="section-tag">Social Apps</span>
        <h2>Our products</h2>
        <p>Coming soon...</p>
        <div className="app-blocks">
          <div className="app-block">
            <h3>SoulBridge App</h3>
            <p>In the process of creation .....</p>
            {/* <img src="https://via.placeholder.com/300x150" alt="AI decision" /> */}
          </div>
          <div className="app-block">
            <h3>VibeTribe App</h3>
            <p>In the process of creation .....</p>
            {/* <img src="https://via.placeholder.com/300x150" alt="Enterprise AI" /> */}
          </div>
        </div>
      </section>

      {/* <section className="services container"> */}
      {/*  <h2>Our Services</h2> */}
      {/*  <p>{`We've worked with...`}</p> */}
      {/*  <div className="service-icons"> */}
      {/*    <img src="https://via.placeholder.com/100" alt="icon1" /> */}
      {/*    <img src="https://via.placeholder.com/100" alt="icon2" /> */}
      {/*    <img src="https://via.placeholder.com/100" alt="icon3" /> */}
      {/*  </div> */}
      {/* </section> */}

      <section className="footer container">
        {/* <h2>The future of your industry <span>starts here</span>.</h2> */}
        {/* <div className="hero-buttons"> */}
        {/*  <Button className="demo-button">Book a Demo</Button> */}
        {/*  <Button className="ai-button" fill="none">Build AI →</Button> */}
        {/* </div> */}
        <div className="copyright">Email: john@iupcloud.com</div>
        <div className="copyright">
          Copyright © Cloud Technology Corporation LIMITED - {getYear()}. All
          Rights Reserved.
        </div>
      </section>
    </div>
  )
}
